import { render, staticRenderFns } from "./ModalUserServers.vue?vue&type=template&id=1bfef170"
import script from "./ModalUserServers.vue?vue&type=script&lang=js"
export * from "./ModalUserServers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports